var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 8H9.3335M6.66683 5.33333H9.3335M9.3335 14V12C9.3335 11.6464 9.19302 11.3072 8.94297 11.0572C8.69292 10.8071 8.35379 10.6667 8.00016 10.6667C7.64654 10.6667 7.3074 10.8071 7.05735 11.0572C6.80731 11.3072 6.66683 11.6464 6.66683 12V14M4.00016 6.66667H2.66683C2.31321 6.66667 1.97407 6.80714 1.72402 7.05719C1.47397 7.30724 1.3335 7.64638 1.3335 8V12.6667C1.3335 13.0203 1.47397 13.3594 1.72402 13.6095C1.97407 13.8595 2.31321 14 2.66683 14H13.3335C13.6871 14 14.0263 13.8595 14.2763 13.6095C14.5264 13.3594 14.6668 13.0203 14.6668 12.6667V6C14.6668 5.64638 14.5264 5.30724 14.2763 5.05719C14.0263 4.80714 13.6871 4.66667 13.3335 4.66667H12.0002M4.00016 14V3.33333C4.00016 2.97971 4.14064 2.64057 4.39069 2.39052C4.64074 2.14048 4.97987 2 5.3335 2H10.6668C11.0205 2 11.3596 2.14048 11.6096 2.39052C11.8597 2.64057 12.0002 2.97971 12.0002 3.33333V14",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2);
export default __webpack_public_path__ + "static/media/building-2.7309cb1f.svg";
export { ForwardRef as ReactComponent };